import { useScrollControllerContext } from './ScrollControllerProvider';

export const useScrollController = () => {
  return useScrollControllerContext()?.scrollController;
};
